module.exports = __webpack_public_path__ + "officialStatic/img/school4Logo.2e1a2d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/school4Logo.png
// module id = 6aSI
// module chunks = 0